/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Topbar/view.blocks to change it.
import LowerSection from './LowerSection/index'
import React from 'react'
import UpperSection from './UpperSection/index'



/** @type {import('Simple/types.js').View} */
export default function Topbar({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/Calendar/Content/Content/Topbar",
  innerRef
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Topbar.Vertical"
  data-view-path={viewPath}
 ref={innerRef}
 className="views-block"
>
<UpperSection
  viewPath={`${viewPath}/UpperSection`}
/>
<LowerSection
  viewPath={`${viewPath}/LowerSection`}
/>
</div>
{children}
</React.Fragment>)
}